import { useState } from "react";
import { useDictionary } from "../../../../../utilities/hooks/UseDictionary";
import pencil from '../../../../../assets/icons/ic_pencil.svg';
import PropTypes from 'prop-types'
import useClientWidth from "../../../../../utilities/hooks/useClientWidth";
import {DateFormatHelper} from "../../../../../utilities/helpers/DateFormatHelper";

const CustomerDetails = ({details,detailsEditHandler}) => {
    const dictionary = useDictionary();
    const clientWidth = useClientWidth();

    return (
        <div
			className="booking-experience-details-container provider-customer-details"
		>
            <div
				className="settings-tab-bar"
				style={{
					justifyContent: 'space-between',
					backgroundColor: 'white',
					alignItems: 'center',
					borderTopLeftRadius: 12,
					borderTopRightRadius: 12
				}}
			>
				<div
					className="settings-tab"
					style={{ color: 'var(--brand-dark-blue)', cursor: 'initial' }}
				>
					{dictionary.details}
				</div>
				<div className='tertiary-button' style={{ gap:'6px'}} onClick={detailsEditHandler}>
                    <img src={pencil}/>
                    {dictionary.edit}
                </div>
			</div>
            <div className="booking-experience-details-content-container thin-scrollbar">
                <div className="participant-row-container" style={{ justifyContent: 'space-between' }}>
                    <h4 style={{ opacity: 0.6, fontWeight: 'normal' }}>
                        {dictionary.providerEmail}
                    </h4>
                    <h4 style={{ fontWeight: 'normal' }}>
                        {details.email}
                    </h4>
                </div>
                <div className="participant-row-container" style={{ justifyContent: 'space-between', marginTop: (clientWidth >= 767 ? '24px' : '16px') }}>
                    <h4 style={{ opacity: 0.6, fontWeight: 'normal' }}>
                        {dictionary.providerPhoneNumber}
                    </h4>
                    <h4 style={{ fontWeight: 'normal' }}>
                        {details.phone ? details.phone : '-'}
                    </h4>
                </div>
                <div className="participant-row-container" style={{ justifyContent: 'space-between', marginTop: (clientWidth >= 767 ? '24px' : '16px') }}>
                    <h4 style={{ opacity: 0.6, fontWeight: 'normal' }}>
                        {dictionary.providerLastActivity}
                    </h4>
                    <h4 style={{ fontWeight: 'normal' }}>
                        {details.last_activity ? DateFormatHelper.monthYearFormat(details.last_activity) : '-'}
                    </h4>
                </div>
                <div className="participant-row-container" style={{ justifyContent: 'space-between', marginTop: (clientWidth >= 767 ? '24px' : '16px') }}>
                    <h4 style={{ opacity: 0.6, fontWeight: 'normal' }}>
                        {dictionary.providerCreateDate}
                    </h4>
                    <h4 style={{ fontWeight: 'normal' }}>
                        {details.created_at ? DateFormatHelper.monthYearFormat(details.created_at) : '-'}
                    </h4>
                </div>
            </div>
        </div>
    )
}

CustomerDetails.propTypes = {
    details: PropTypes.object.isRequired,
    detailsEditHandler: PropTypes.func.isRequired
}
export default CustomerDetails;